//Error messages definition for file

export const 
INVALID_FILE_FORMAT= "Nieprawidłowy format pliku. Plik powinien być zapisany w jednym z poniższych formatów: JPEG, PNG, BMP, PDF, DOC, DOCX",
PARSE_FILE_ERROR= "Wystąpił błąd podczas podpinania pliku.",
VALIDATE_FILE_CONTENT= "Podpięty plik jest pusty!",
VALIDATE_FILE_MAX_SIZE= "Maksymalny rozmiar podpinanego pliku wynosi 5 MB!",
VALIDATE_FILES_MAX_NUMBER= "Maksymalna liczba plików możliwych do podpięcia dla pozycji zgłoszenia wynosi 3!",
FILE_TO_ADD_EXIST_IN_FILE_ARRAY="Plik o danej nazwie został już dodany. Zmień nazwę pliku i spróbuj ponownie";


// WEBPACK FOOTER //
// ./src/const/ErrorMessages/FileErrorMessages.js